// src/data/platformSolutions.js
import jira from "./icons/jira.png";
import Confluence from "./icons/Confluence.png";
import JiraService from "./icons/Jira-Service-Management.png";
import zendesk from "./icons/zendesk.png";
import monday from "./icons/monday.png";
import Release from "./icons/Release-Manager.jpeg";
import Custom from "./icons/Custom.png";
import Sitemap from "./icons/Sitemap.png";
import Latex from "./icons/Latex Equations for confluence.jpg.jpeg";
import Dynamic from "./icons/Dynamic Variables for confluence.png";
import Extendedfree from "./icons/Extended JSM Portal- Free.jpeg";
import Extendedpro from "./icons/Extended JSM Portal - Pro.jpeg";
import Latexequation from "./icons/Latex Equation For Jira (2).png";
import Grid from "./icons/Grid View For Jira.jpeg";
import Options from "./icons/Options Manager For Jira.jpeg";
import Component from "./icons/Component Manager For Jira.jpeg";
import Cascade from "./icons/Cascade Pro for Jira.jpeg";
import CustomHTML from "./icons/Custom HTML and iFrame Embedder.jpeg";
import Bulk from "./icons/Bulk Work Items Archiver for jira.jpeg";
import Extensive from "./icons/Extensive Fields.jpeg";
import Open from "./icons/Open Pull Request Condition for Jira.jpeg";
import ThreadWave from "./icons/ThreadWave Comments for Jira & JSM.jpeg";
import Real from "./icons/Real-Time Work Item User.jpeg";
import Bulks from "./icons/Bulk Filter Manager for Jira.jpeg";
import Smart from "./icons/Smart JSON Renderer for jira.jpeg";
import Secure from "./icons/Secure Vault for Jira.jpeg";
import Mural from "./icons/Mural Diagrams for Jira.jpeg";
import Unified from "./icons/Unified Diagram for jira.jpeg";
import JSM from "./icons/JSM Metrics+.jpeg";
import Auto from "./icons/Auto Page Sorter.jpeg";
import CustomHTMLEmbedder from "./icons/Custom HTML Embedder.jpeg";
import Who from "./icons/Who Deleted My Page.jpeg";
import Iframe from "./icons/Iframe Embedder.jpeg";
import EmbeddedHTML from "./icons/Embedded HTML.jpeg";
import TimeStatus from "./icons/Time in Status.jpeg";
import PlantUML from "./icons/PlantUML for Workdocs.png";
import LaTeX from "./icons/latexequations.jpeg";
import Mermaid from "./icons/mermaid_diagrams_for_workdocs.jpeg";
import PlantUMLDiagrams from "./icons/plantuml-diagrams.png";
import Code from "./icons/code_to_mermaid_diagrams.png";
import iFrame from "./icons/htmliframe.jpg.jpeg";
import ItemMerger from "./icons/item_merger.jpg.jpeg";
import NestedComments from "./icons/Nested Comments.jpeg";

import phoneIcon from "./icons/phone.png";
import apptracker from "./icons/apptracker.jpeg";
import dailytracker from "./icons/daily tracker.jpeg";
import walkflow from "./icons/walkflow.jpeg";
import smartleave from "./icons/smart leave planner.png";
import grid from "./icons/grid.png";
import worktype from "./icons/worktypage CGF jira.png";
import StatusTrail from "./icons/StatusTrail.png";

const platformSolutions = [
  {
    id: "jira",
    title: "Jira App Development",
    color: "#187BE9",
    description:
      "Custom Jira apps and plugins that extend functionality and simplify workflows.",
    features: [
      "Workflow customization",
      "Project management setup",
      "Automation rules",
      "Dashboard creation",
      "User management",
      "Reporting and analytics,",
    ],
    image: jira,
    apps: [
      {
        id: "release-manager",
        image: Release,
        title: "Release Manager for Jira",
        tagline:
          "Unleash Version Control, Empower Product Owners: Elevate Jira Release Management with Ease",
        link: "https://marketplace.atlassian.com/apps/1233307/release-manager-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/RM/pages/15958132/Overview",
      },
      {
        id: "latex-equations-jira",
        image: Latexequation,
        title: "LaTex Equations for Jira",
        tagline: "Power Up Jira with LaTeX Equation",
        link: "https://marketplace.atlassian.com/apps/1237240/latex-equations-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/LEFJ/pages/200441882/Overview",
      },
      {
        id: "grid-view",
        image: Grid,
        title: "Grid View For Jira",
        tagline: "Your Data, Your Way With Grids",
        link: "https://marketplace.atlassian.com/apps/1236558/grid-view-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/IGVFJ/pages/163643398/Getting+started",
      },
      {
        id: "options-manager",
        image: Options,
        title: "Options Manager For Jira",
        tagline:
          "Empower Your Teams: Delegate Custom Field Option Management with Ease",
        link: "https://marketplace.atlassian.com/apps/1233614/options-manager-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/OM/pages/22544637/Overview",
      },
      {
        id: "component-manager",
        image: Component,
        title: "Component Manager For Jira",
        tagline:
          "Empower Your Projects: Seamless Component Control for Every Team Membe",
        link: "https://marketplace.atlassian.com/apps/1233387/component-manager-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/CM/pages/15990893/Overview",
      },
      {
        id: "cascade-pro",
        image: Cascade,
        title: "Cascade Pro for Jira",
        tagline: "Multi-Level Option Configuration, Simplified",
        link: "https://marketplace.atlassian.com/apps/1237957/cascade-pro-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/CMO1/pages/240484809/Overview",
      },
      {
        id: "custom-html-iframe",
        image: CustomHTML,
        title: "Custom HTML and iFrame Embedder",
        tagline: "Extend Jira with flexible HTML and iframe embeds",
        link: "https://marketplace.atlassian.com/apps/1238347/custom-html-and-iframe-embedder?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/HTMLiFrame/pages/278855715/Overview",
      },
      {
        id: "bulk-archiver",
        image: Bulk,
        title: "Bulk Work Items Archiver for jira",
        tagline: "Bulk archive issues with ease",
        link: "https://marketplace.atlassian.com/apps/4038921321/bulk-work-items-archiver-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/BWIAFJ/pages/321388546/Overview",
      },
      {
        id: "extensive-fields",
        image: Extensive,
        title: "Extensive Fields",
        tagline:
          "Unleash the Power of Customization with JIRA Extensive Custom Fields",
        link: "https://marketplace.atlassian.com/apps/1232291/extensive-fields?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/EF/pages/3276835/Overview",
      },
      {
        id: "open-pull-request",
        image: Open,
        title: "Open Pull Request Condition for Jira",
        tagline: "Quality Gatekeeper: No Open Pull Requests, No Problem",
        link: "https://marketplace.atlassian.com/apps/1233927/open-pull-request-condition-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/OPRCFJ/pages/36471082/Overview",
      },
      {
        id: "threadwave-comments-for-jira-jsm",
        image: ThreadWave,
        title: "ThreadWave Comments for Jira & JSM",
        tagline: "Seamless Threads, Smarter Communication",
        link: "https://marketplace.atlassian.com/apps/1236073/threadwave-comments-for-jira-jsm?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/TCFJ1/pages/105185662/Overview",
      },
      {
        id: "real-time-user",
        image: Real,
        title: "Real-Time Work Item User",
        tagline: "Live user activity inside your issues",
        link: "https://marketplace.atlassian.com/apps/357519451/real-time-work-item-user?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/TrackingCu/pages/379518977/Overview",
      },
      {
        id: "bulk-filter-manager",
        image: Bulks,
        title: "Bulk Filter Manager for Jira",
        tagline:
          "Manage Jira filters with bulk owner updates , quick search, inactive owner tracking",
        link: "https://marketplace.atlassian.com/apps/4009602545/bulk-filter-manager-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/BulkFilter/pages/701530118/Overview",
      },
      {
        id: "smart-json-jira",
        image: Smart,
        title: "Smart JSON Renderer for jira",
        tagline:
          "Render, explore, and analyze JSON in Jira with interactive tree, code, and text views, search and customizable display options",
        link: "https://marketplace.atlassian.com/apps/2422840370/smart-json-renderer-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/JRID/pages/578060291/Overview",
      },
      {
        id: "secure-vault-jira",
        image: Secure,
        title: "Secure Vault for Jira",
        tagline:
          "Securely store and manage sensitive Jira issue data with user, group, role, and field-based access control",
        link: "https://marketplace.atlassian.com/apps/4183602048/secure-vault-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/SVFJ/pages/672825345/Overview",
      },
      {
        id: "mural-jira",
        image: Mural,
        title: "Mural Diagrams for Jira",
        tagline: "Embed Mural diagrams directly in Jira issues",
        link: "https://marketplace.atlassian.com/apps/1254071308/mural-diagrams-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/MD1/pages/456818703/Overview",
      },
      {
        id: "unified-diagram",
        image: Unified,
        title: "Unified Diagram for jira",
        tagline: "From Text to Diagrams—Instantly in Jira",
        link: "https://marketplace.atlassian.com/apps/1237511/unified-diagram-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/UDFJ/pages/214237189/OverView",
      },
      {
        id: "jsm-metrics",
        image: JSM,
        title: "JSM Metrics",
        tagline:
          "Track. Analyze. Improve — Smart Jira insights for every project and team",
        link: "https://marketplace.atlassian.com/apps/2120936231/jsm-metrics?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/JM/pages/379715587/Overview",
      },
      {
        id: "Smart-Leave-Planner-for-Jira",
        image: smartleave,
        title: "Smart Leave Planner for Jira",
        tagline:
          "Plan Leave, Assign Coverers, Stay Organized",
        link: "https://marketplace.atlassian.com/apps/163607577/smart-leave-planner-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/LM/pages/787316737/Overview",
      },
      {
        id: "Grid-Tables-for-Jira",
        image: grid,
        title: "Grid Tables for Jira",
        tagline:
          "Create Custom Grid Tables",
        link: "https://marketplace.atlassian.com/apps/363762954/grid-tables-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/GTFJ/pages/819986433/Overview",
      },
      {
        id: "Work-Type-Change-Guard-for-Jira",
        image:worktype,
        title: "Work Type Change Guard for Jira",
        tagline:
          "Control who can change Work Types across your Jira projects with flexible user-based restriction rules",
        link: "https://marketplace.atlassian.com/apps/892222051/work-type-change-guard-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/ANJ/pages/883687426/Overview",
      },
      {
        id: "StatusTrail-for-Jira",
        image:StatusTrail,
        title: "StatusTrail for Jira",
        tagline:
          "Track status time, assignee activity, and work item duration in Jira",
        link: "https://marketplace.atlassian.com/apps/3670565074/statustrail-for-jira?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/WITTFJ/pages/927498256/Overview",
      },
    ],
  },
  {
    id: "Confluence",
    title: "Confluence App Development",
    color: "#4A9EF5",
    description:
      "Custom Confluence apps that improve collaboration and knowledge management.",
    features: [
      "Knowledge base setup",
      "Team collaboration spaces",
      "Document organization",
      "Templates customization",
      "Permissions management",
    ],
    image: Confluence,
    apps: [
      {
        id: "auto-page-sorter",
        image: Auto,
        title: "Auto Page Sorter",
        tagline: "Alphabetical order, always in order",
        link: "http://marketplace.atlassian.com/apps/1237790/auto-page-sorter?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/APS/pages/235044881/Overview",
      },
      {
        id: "custom-html-embedder",
        image: CustomHTMLEmbedder,
        title: "Custom HTML Embedder",
        tagline: "Your HTML. Your design. Right inside Confluence",
        link: "https://marketplace.atlassian.com/apps/1238391/custom-html-embedder?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/CHE/pages/283574307/Overview",
      },
      {
        id: "who-deleted-my-page",
        image: Who,
        title: "Who Deleted My Page",
        tagline: "Know What's Gone — And Who Removed It",
        link: "https://marketplace.atlassian.com/apps/1238414/who-deleted-my-page-s?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/WDMP/pages/287736227/Overview",
      },
      {
        id: "dynamic-variables",
        image: Dynamic,
        title: "Dynamic Variables for Confluence",
        tagline:
          "Dynamic Variables simplifies Confluence content by enabling reusable variables with real-time preview",
        link: "https://marketplace.atlassian.com/apps/2853233719/dynamic-variables-for-confluence?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/SVFC/pages/617480196/Overiew",
      },
      {
        id: "latex-confluence",
        image: Latex,
        title: "Latex Equations for Confluence",
        tagline: "Smart LaTeX equations with live preview and templates",
        link: "https://marketplace.atlassian.com/apps/444516374/latex-equations-for-confluence?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/LEFC/pages/578781185/Overview",
      },
      {
        id: "sitemap-renderer",
        image: Sitemap,
        title: "SiteMap Renderer",
        tagline:
          "Turn complex sitemap XML into structured, easy-to-analyze views",
        link: "https://marketplace.atlassian.com/apps/1481810168/sitemap-renderer?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/Sitemap/pages/541196294/Overiew",
      },
      {
        id: "mural-confluence",
        image: Mural,
        title: "Mural Diagrams for Confluence",
        tagline: "Embed and view Mural diagrams seamlessly in Confluence pages",
        link: "https://marketplace.atlassian.com/apps/702385901/mural-diagrams-for-confluence?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/CMD/pages/458915851/Overview",
      },
      {
        id: "secure-vault-confluence",
        image: Secure,
        title: "Secure Vault for Confluencee",
        tagline:
          "Securely store and share sensitive data in Confluence with controlled user and group access",
        link: "https://marketplace.atlassian.com/apps/2302626467/secure-vault-for-confluence?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/SFC/pages/612958209/Overview",
      },
      {
        id: "smart-json-confluence",
        image: Smart,
        title: "Smart JSON Renderer for Confluence",
        tagline:
          "Render and explore JSON data in interactive Tree Code and Text views directly inside Confluence",
        link: "https://marketplace.atlassian.com/apps/1455889160/smart-json-renderer-for-confluence?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/JRID/pages/578060291/Overview",
      },
    ],
  },
  {
    id: "Jira Service Management",
    title: "Jira Service Management App Development",
    color: "#74B9FF",
    description:
      "Custom JSM apps that simplify service management and support workflows.",
    features: [
      "Service request workflows",
      "Incident management",
      "Asset management",
      "Support automation",
      "SLA management",
    ],
    image: JiraService,
    apps: [
      {
        id: "extended-jsm-free",
        image: Extendedfree,
        title: "Extended JSM Portal-Free",
        tagline: "Extend Your Reach, Enhance Your Portal",
        link: "https://marketplace.atlassian.com/apps/1234168/extended-jsm-portal-free?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/EJP/pages/46432274/Overview",
      },
      {
        id: "extended-jsm-pro",
        image: Extendedpro,
        title: "Extended JSM Portal-Pro",
        tagline: "Empower Your Portal, Enhance Your Service",
        link: "https://marketplace.atlassian.com/apps/1234616/extended-jsm-portal-pro?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/EJPP/pages/62849336/Overview",
      },
      {
        id: "threadwave-jsm",
        image: ThreadWave,
        title: "ThreadWave Comments for Jira & JSM",
        tagline: "Seamless Threads, Smarter Communication",
        link: "https://marketplace.atlassian.com/apps/1236073/threadwave-comments-for-jira-jsm?hosting=cloud&tab=overview",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/TCFJ1/pages/105185662/Overview",
      },
    ],
  },
  {
    id: "Zendesk",
    title: "Zendesk App Development",
    color: "#0F5FC4",
    description:
      "Custom Zendesk apps that improve customer support and team productivity.",
    features: [
      "Ticket workflow setup",
      "Automation rules",
      "Support management",
      "Customer engagement solutions",
      "Analytics dashboard",
    ],
    image: zendesk,
    apps: [
      {
        id: "iframe-embedder",
        image: Iframe,
        title: "Iframe Embedder",
        tagline: "Embed external web pages directly inside Zendesk.",
        link: "https://www.zendesk.com/in/marketplace/apps/support/1162756/iframe-embedder/?queryID=925e998751bb0759bf98c150ed19a83c",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/ZA/pages/833421327/Overview",
      },
      {
        id: "embedded-html",
        image: EmbeddedHTML,
        title: "Embedded HTML",
        tagline: "Render custom HTML content inside Zendesk.",
        link: "https://www.zendesk.com/in/marketplace/apps/support/1170516/html-embedder/?queryID=f25d05484e9db529446c8c5ae564cc3d",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/ZA/pages/833421351/Overview.",
      },
      {
        id: "time-in-status",
        image: TimeStatus,
        title: "Time in Status",
        tagline:
          "Track and visualize ticket status durations with charts and tables.",
        link: "https://www.zendesk.com/in/marketplace/apps/support/1165185/time-in-status/?queryID=4cabe7a03f491dbfab22af9a3fd0615a",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/ZA/pages/834207769/Overview",
      },
    ],
  },
  {
    id: "monday.com",
    title: "Monday.com App Development",
    color: "#083D91",
    description:
      " Custom Monday.com apps that simplify project management and team collaboration.",
    features: [
      "Board customization",
      "Task management setup",
      "Workflow automation",
      "Team collaboration",
      "Reporting dashboards",
    ],
    image: monday,
    apps: [
      {
        id: "plantuml-workdocs",
        image: PlantUML,
        title: "PlantUML for Workdocs",
        tagline: "Write, preview, and insert UML diagrams in Workdocs.",
        link: "https://monday.com/marketplace/listing/10000800/plantuml-for-workdocs",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/PlantUML/pages/228819355/Overview",
      },
      {
        id: "latex-equations",
        image: LaTeX,
        title: "LaTeX Equations",
        tagline: "Create & attach LaTeX formulas in monday items",
        link: "https://monday.com/marketplace/listing/10000835/latex-equations",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/LEFJ/pages/200441882/Overview",
      },
      {
        id: "mermaid-diagrams",
        image: Mermaid,
        title: "Mermaid Diagrams for Workdocs",
        tagline: "Mermaid Diagrams, Insert diagrams without leaving editor",
        link: "https://monday.com/marketplace/listing/10000838/mermaid-diagrams-for-workdocs",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/MFW/pages/235864079/Overview",
      },
      {
        id: "plantuml-diagrams",
        image: PlantUMLDiagrams,
        title: "PlantUML Diagrams",
        tagline: "PlantUML Diagrams for visual items & dashboards in monday",
        link: "https://monday.com/marketplace/listing/10000846/plantuml-diagrams",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/PlantUML/pages/228819355/Overview",
      },
      {
        id: "code-mermaid",
        image: Code,
        title: "Code to Mermaid Diagrams",
        tagline: "Create and manage Mermaid diagrams in monday items.",
        link: "https://monday.com/marketplace/listing/10000863/code-to-mermaid-diagrams",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/MFW/pages/235864079/Overview",
      },
      {
        id: "iframe-html-embed",
        image: iFrame,
        title: "iFrame and HTML Embed Pro",
        tagline: "Embed images, pages, or videos via URL or HTML.",
        link: "https://monday.com/marketplace/listing/10000879/iframe-and-html-embed-pro",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/iFrame/pages/279412804/Overview",
      },
      {
        id: "item-merger",
        image: ItemMerger,
        title: "Item Merger",
        tagline: "Merge items with replace, append, and archive options.",
        link: "https://monday.com/marketplace/listing/10000923/item-merger",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/IM/pages/303366196/Overview",
      },
      {
        id: "nested-comments",
        image: NestedComments,
        title: "Nested Comments",
        tagline: "Organize monday.com Updates with Threads",
        link: "https://monday.com/marketplace/listing/10001101/nested-comments",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/NC/pages/504659978/Overview",
      },
    ],
  },
  {
    id: "Customized Solutions",
    title: "Custom Software Development",
    color: "#187BE9",
    description:
      "Need a custom solution? We build scalable software, Android apps, and business platform applications tailored to your requirements.",
    features: [
      "Workflow customization",
      "Dashboard customization",
      "Process automation",
      "Reporting solutions",
      "Platform optimization",
      "Business-specific configurations",
    ],
    image: Custom,
  },
  {
    id: "android",
    title: "Android App Development",
    color: "#5f85eb",
    description:
      "Build high‑performance native Android apps for your business – from scratch or integrated with your existing ecosystem.",
    features: [
      "Custom UI/UX design",
      "Offline data sync",
      "Push notifications & Firebase",
      "Secure API integration",
      "Device compatibility testing",
      "Play Store deployment",
    ],
    image: phoneIcon,
    apps: [
      {
        id: "daily-tracker",
        image: dailytracker,
        title: "Daily Tracker",
        tagline: "Small Tasks. Big Achievements",
        link: "https://play.google.com/store/apps/details?id=com.alvanium.dailydo",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/DailyDo/pages/596869125/Overview",
      },
      {
        id: "walk-flow",
        image: walkflow,
        title: "Walk Flow",
        tagline: "Walk Smarter. Stay Healthier.",
        link: "https://play.google.com/store/apps/details?id=com.alvanium.walk_flow",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/WF/pages/635043841/Overview",
      },
      {
        id: "app-tracker",
        image: apptracker,
        title: "App Tracker",
        tagline: "Take Control of Your Screen Time.",
        link: "https://play.google.com/store/apps/details?id=com.alvanium.app_tracker",
        documentation: "https://alvanium.atlassian.net/wiki/spaces/AT1/pages/714375170/Overview",
      },
    ],
  },
];

export default platformSolutions;